import { useQuery } from "react-query";
import {
  apiListConversations,
  IListConversationsParams,
} from "../../../../../apiCoreV3/conversation/apiListConversations";
import { apiListCandidates } from "../../../../../apiCoreV3/candidate/apiListCandidates";
import {
  ExtractFnReturnType,
  QueryConfig,
} from "../../../../../lib/react-query";
import { conversationKeys } from "../util/conversation.query-keys";

export const getConversations = async (
  params: IListConversationsParams = {}
) => {
  const response = await apiListConversations({
    orderBy: "updatedAt",
    order: "desc",
    ...params,
  });

  const contactIds = response.data.map(
    (conversation) => conversation.contact_id
  );

  const candidates = await apiListCandidates({ id: contactIds });

  const conversationsWithCandidates = response.data.map((conversation) => ({
    ...conversation,
    candidate: candidates.find((c) => c.id === conversation.contact_id),
  }));

  return {
    conversations: conversationsWithCandidates,
    totalItems: response.info.count_all ?? 0,
  };
};

type QueryFnType = typeof getConversations;

type UseConversationsOptions = {
  config?: QueryConfig<QueryFnType>;
  params?: IListConversationsParams;
};

export const useConversations = ({
  config,
  params,
}: UseConversationsOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: conversationKeys.list(params ?? {}),
    queryFn: () => getConversations(params),
  });
};
